import * as React from "react";
import {Component} from "react";
import styles from "../../styles/flyouts/sites/SitesFlyout.scss";
import * as _ from "lodash";
import CloseBigIcon from "../../assets/images/close-big-15x15.svg";
import {__, setTableParams} from "../../core/utils";
import {subscribe} from "react-contextual/dist/react-contextual.es";
import Localization from "../../helpers/Localization";
import {setNotification} from "../../redux/actions/general/notification";
import withRouter from "react-router/es/withRouter";
import {deleteSites, listSites} from "../../redux/actions/table/sites";
import Tooltip from "../../components/Tooltip";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import {hideAlertbox, showAlertbox} from "../../redux/actions/general/alertbox";
import classNames from "classnames";
import Properties from "./Properties";

@subscribe(Localization, "localization")
@withRouter
class SitesFlyout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: 'properties'
        }
    }

    render() {
        const {data, readAction} = this.props;

        return (
            <div className={styles.preview}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <span>
                            <strong>{data.code}:</strong>{_.get(data.title, _.findKey(_.get(data, 'project_languages'), primary => primary == 1))}
                        </span>
                        <CloseBigIcon onClick={() => setTimeout(() => {
                            setTableParams('sites', {
                            clicked_row: undefined
                        })}, 100)}/>
                    </div>
                    <div className={styles.actions}>
                        <div className={styles.actionWrapper}>
                            <Tooltip text={__('sites.tooltip.delete-site')} key={_.uniqueId()}>
                                <DeleteIcon
                                    onClick={e => {
                                        e.stopPropagation();

                                        showAlertbox({
                                            color: "red",
                                            title: __('general.alert.are-you-sure'),
                                            description: __('sites.alert.delete-confirmation'),
                                            buttons: [
                                                {
                                                    color: 'lightGray',
                                                    text: __('general.alert.no-close'),
                                                    onClick: 'close'
                                                },
                                                {
                                                    color: 'gray',
                                                    text: __('general.alert.yes-delete'),
                                                    onClick: () => {
                                                        deleteSites([data.id]).then(() => {
                                                            hideAlertbox();

                                                            setNotification(__('sites.alert.deleted'));
                                                            listSites(this.props.match.params.stage);

                                                            setTableParams('sites', {
                                                                clicked_row: undefined
                                                            });
                                                        });
                                                    },
                                                }
                                            ]
                                        })
                                    }}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className={styles.tabs}>
                    <span className={classNames(this.state.active == 'properties' && styles.active)} onClick={() => this.setState({active: 'properties'})}>{__('sites.flyout.properties')}</span>
                </div>
                {!_.isEmpty(data) && this.state.active == 'properties' && <Properties data={data} readAction={readAction} />}
            </div>
        );
    }
}

export default SitesFlyout;
